import Vue from 'vue';
import widgetEventsServices from '../api/WidgetEvents';

export default () => ({
  widgetEvents: { ...widgetEventsServices(Vue.$service) },
});
